import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

import Backdrop from "@material-ui/core/Backdrop";
import makeStyles from "@material-ui/core/styles/makeStyles";

import { OVERVIEW_URL } from "features/overview/state/overview.sections";

import LoadingBackdropComponent from "features/budget/wizard/views/loading-backdrop/loading-backdrop.component";
import loadingBackdropStyles from "features/budget/wizard/views/loading-backdrop/loading-backdrop.styles";
import { clearDueDates } from "features/budget/schedules/state/schedules.storage";
import {
  clearScenarioLevelAssumptions,
  clearTemplates,
} from "features/budget/templates/state/template.storage";
import {
  deleteBudget,
  // eslint-disable-next-line camelcase
  LEGACY_deleteBudget,
} from "features/budget/wizard/state/wizard.storage";
import { getLocalStorageItem } from "common/utils/storage/local-storage";
import { CURRENT_BUDGET } from "features/budget/budget.constants";
import isMSLegacy from "common/utils/is-ms-legacy";

const useStyles = makeStyles(loadingBackdropStyles);

function LoadingBackdrop({ loading, success }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const history = useHistory();

  useEffect(() => {
    async function afterSuccess() {
      function redirectToOverview() {
        setOpen(false);
        history.push(OVERVIEW_URL);
      }

      let timeoutID;
      if (success) {
        const currentBudget = getLocalStorageItem(CURRENT_BUDGET);

        await clearScenarioLevelAssumptions(currentBudget);
        await clearTemplates();
        await clearDueDates();
        if (isMSLegacy() === true) {
          LEGACY_deleteBudget();
        } else {
          await deleteBudget();
        }

        timeoutID = setTimeout(redirectToOverview, 2000);
      }

      return function cleanup() {
        clearTimeout(timeoutID);
      };
    }

    afterSuccess();
  }, [history, success]);

  useEffect(() => {
    if (!loading && !success) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [loading, success]);

  return (
    <Backdrop className={classes.backdrop} open={open} timeout={200}>
      <LoadingBackdropComponent loading={loading} success={success} />
    </Backdrop>
  );
}

LoadingBackdrop.propTypes = {
  loading: PropTypes.bool.isRequired,
  success: PropTypes.bool.isRequired,
};

export default LoadingBackdrop;
